const courseTypes = [
   {
      id: 'undergrad',
      label: 'Undergraduate',
      courseloop: 'Undergraduate,Cross Institution Program,Non-Award Course',
      showAsFilter: true,
      feeCourseType: 'Undergraduate Degree (Bachelors)'
   },
   {
      id: 'honours',
      label: 'Honours',
      courseloop: 'Honours',
      showAsFilter: true,
      feeCourseType: 'Undergraduate Degree (Bachelors)'
   },
   {
      id: 'postgrad',
      label: 'Postgraduate',
      courseloop: 'Postgraduate',
      showAsFilter: true,
      feeCourseType: 'Postgraduate Degree by Coursework'
   },
   {
      id: 'research',
      label: 'Research',
      courseloop: 'Research',
      showAsFilter: false,
      feeCourseType: 'Research Degree'
   }
];

module.exports = courseTypes;
